import { generateParams } from '@/utils/helpers'
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper'

import instance from '../instance'

const errorMapper = new ErrorMapper()
const resource = '/dataLists'

export default {
  list: async function ({ params = [], token }) {
    try {
      const paramsString = generateParams(params)
      return await instance.get(`${resource}/list${paramsString}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  get: async function ({ token, category }) {
    try {
      return await instance.get(`${resource}/${category}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
}
